import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PaginatedSearchResponse } from 'lib';

export interface PodDomainMappingDto {
    pod: string;
}

@Injectable({
    providedIn: 'root'
})
export class PodSearchService {
    private readonly http = inject(HttpClient);


    private readonly baseUrl = environment.apiUrl + '/api/v1/pod-domain-mapping';

    searchPods(searchTerm = ''): Observable<string[]> {
        const trimmed = searchTerm.trim();
        let params = new HttpParams().set('page', 0).set('size', 5);
        if (trimmed.length > 0) {
            params = params.set('searchTerm', trimmed);
        }
        return this.http
            .get<PaginatedSearchResponse<PodDomainMappingDto>>(`${this.baseUrl}/search`, { params })
            .pipe(map(response => response.content.map(dto => dto.pod)));
    }
}
